import React from 'react';
import '../styles/skills.css';  // Ensure this CSS file is included

const Skills = () => {
  const skills = {
    Languages: [
      { name: 'Python', level: 'Advanced', proficiency: 100 },
      { name: 'Node/TypeScript', level: 'Advanced', proficiency: 90 },
      { name: 'Go', level: 'Intermediate', proficiency: 60 },
      { name: 'Java', level: 'Intermediate', proficiency: 50 },
      { name: 'SQL', level: 'Advanced', proficiency: 90 },
    ],
    Backend: [
      { name: 'FastAPI', level: 'Advanced', proficiency: 100 },
      { name: 'Flask', level: 'Advanced', proficiency: 100 },
      { name: 'OpenAPI/Swagger', level: 'Advanced', proficiency: 100 },
      { name: 'SQLAlchemy', level: 'Advanced', proficiency: 95 },
      { name: 'REST API Design', level: 'Advanced', proficiency: 100 },
    ],
    Data: [
      { name: 'PostgreSQL', level: 'Advanced', proficiency: 100 },
      { name: 'DynamoDB', level: 'Advanced', proficiency: 100 },
      { name: 'Redis', level: 'Advanced', proficiency: 85 },
      { name: 'Oracle', level: 'Advanced', proficiency: 75 },
      { name: 'Kafka', level: 'Advanced', proficiency: 80 },
    ],
    'Cloud & Infra': [
      { name: 'AWS', level: 'Advanced', proficiency: 100 },
      { name: 'CloudFormation/SAM', level: 'Advanced', proficiency: 100 },
      { name: 'CDK', level: 'Advanced', proficiency: 90 },
      { name: 'Terraform', level: 'Intermediate', proficiency: 70 },
      { name: 'Docker/K8s', level: 'Intermediate', proficiency: 70 },
    ],
    'CI/CD': [
      { name: 'GitHub Actions', level: 'Advanced', proficiency: 100 },
      { name: 'GitLab CI', level: 'Advanced', proficiency: 90 },
      { name: 'Azure DevOps', level: 'Intermediate', proficiency: 60 },
    ],
  };

  return (
    <div className="skills-container">
      {Object.keys(skills).map((category) => (
        <div key={category} className="skills-section">
          <h3 className="category-title">{category}</h3>
          {skills[category].map((skill, index) => (
            <div key={skill.name} className="skill-bar">
              <p className="skill-name">
                {skill.name}: {skill.level}
              </p>
              <div className="bar-container">
                <div className="bar">
                  <div
                    className={`bar-filled ${
                      skill.proficiency === 100 ? 'full' : ''
                    }`}
                    style={{ width: `${skill.proficiency}%` }}
                    data-index={index}
                  ></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default Skills;
